import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { IsOptional, IsString } from 'class-validator';
import { LocalTimeRange } from '../../type/shared';
/** Request body for updating on-the-record times for a stream recording. */
export class UpdateOnTheRecordTimesBody {
    /**
     * @param existing The existing time range.
     * @param updated The updated time range.
     * @param conflictResolutionToken An optional token used to resolve conflicts.
     */
    constructor(existing, updated, conflictResolutionToken) {
        this.existing = existing;
        this.updated = updated;
        this.conflictResolutionToken = conflictResolutionToken;
    }
}
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", LocalTimeRange)
], UpdateOnTheRecordTimesBody.prototype, "existing", void 0);
__decorate([
    Type(() => LocalTimeRange),
    __metadata("design:type", LocalTimeRange)
], UpdateOnTheRecordTimesBody.prototype, "updated", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], UpdateOnTheRecordTimesBody.prototype, "conflictResolutionToken", void 0);
